import { Link, NavLink } from "react-router-dom";
import { Radio } from "lucide-react";

const navItems = [
  { to: "/", label: "Accueil", end: true },
  { to: "/wall", label: "WallTunes" },
  { to: "/offre-stream", label: "Diffuser ma radio" },
  { to: "/offre-pwa", label: "Créer ma PWA" },
  { to: "/contact", label: "Contact" },
];

export function MwHeader() {
  return (
    <header className="mw-header" data-testid="mw-header">
      <div className="mw-header-inner">
        <Link to="/" className="mw-brand" data-testid="mw-brand-link">
          <span className="mw-brand-mark" aria-hidden="true">
            <Radio size={18} strokeWidth={2.2} />
          </span>
          <span className="mw-brand-text">
            <span className="mw-brand-name">Media</span>
            <span className="mw-brand-name mw-brand-name-accent">WebRadio</span>
          </span>
        </Link>

        <nav className="mw-nav" aria-label="Navigation principale">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                isActive ? "mw-nav-link mw-nav-link-active" : "mw-nav-link"
              }
              data-testid={`mw-nav-${item.to.replace(/\//g, "") || "home"}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
